import React from "react";
import Form from "./SignIn/Form";

export default function SignIn() {
  return (
    <div className="signInContainer">
      <Form />
    </div>
  );
}
